import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { forgotPassword, formatApiError } from "@/auth";
import { AuthShell, Field, ErrorBox, PrimaryButton } from "@/components/AuthShell";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(formatApiError(err, "Could not send the reset email."));
    } finally { setBusy(false); }
  };

  return (
    <AuthShell testId="forgot-screen" title="Reset your password" subtitle="Enter your account email and we'll send you a secure link. The link works once and expires in 10 minutes.">
      {sent ? (
        <div data-testid="forgot-sent" className="rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-4 text-sm text-emerald-200">
          <div className="flex items-center gap-2 font-semibold"><MailCheck className="h-4 w-4" /> Check your inbox</div>
          <p className="mt-1 text-emerald-200/80">If an account exists for <span className="font-mono">{email.trim()}</span>, a reset link is on its way. It expires in 10 minutes.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <Field label="Email" testId="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required autoFocus />
          <ErrorBox error={error} testId="forgot-error" />
          <PrimaryButton testId="forgot-submit" type="submit" disabled={busy}>
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Email me a reset link
          </PrimaryButton>
        </form>
      )}
      <p className="mt-5 text-center text-xs text-slate-500">
        <Link data-testid="back-to-login-link" to="/login" className="text-orange-400 hover:underline">Back to sign in</Link>
      </p>
    </AuthShell>
  );
};

export default ForgotPassword;
